export const selectMaAccPgContainer = (state) => state.containers.loginPageReducer;

// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectLoading = (state) => selectMaAccPgContainer(state).get('loading');
export const selectFormPhoneRequestConfig = (state) => selectMaAccPgContainer(state).get('formRequestConfig');
export const selectPinForAuthorizeLoaded = (state) => selectMaAccPgContainer(state).get('pinForAuthorizeLoaded');
export const selectPhoneNumber = (state) => selectMaAccPgContainer(state).get('phoneNumber');
export const selectPinNumber = (state) => selectMaAccPgContainer(state).get('pinNumber');
export const selectpinForAuthorizeError = (state) => selectMaAccPgContainer(state).get('pinForAuthorizeError');
export const selectsubscriptionUriError = (state) => selectMaAccPgContainer(state).get('subscriptionUri');
export const selectRegisterForm = (state) => selectMaAccPgContainer(state).get('registerForm');
export const selectInitialDataConfig = (state) => selectMaAccPgContainer(state).get('initialDataConfig');
export const selectSubscriptionPlan = (state) => selectMaAccPgContainer(state).get('subscriptionPlan');
